import Dashboard from "components/dashboard";
import Customers from "components/customers";
import Login from "components/authentication/login";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoutes from "./protected-routes/index";
import PublicRoutes from "./public-route/index";
import Applications from "components/applications";
import ExternalSystems from "components/external-systems";
import Users from "components/users";
import AddUsers from "components/users/addUsers";
import CompleteRegistration from "components/users/completeRegistration";
import Reports from "components/reports";
import ComingSoon from "common/ComingSoon";
import InviestorAdmin from "components/investorAdmin";
import AdhocJobAdmin from "components/AdhocJob";
import ForgotPassword from "components/authentication/forgot-password";
import ResetPassword from "components/authentication/reset-password";
import ChangePassword from "components/authentication/change-password";
import Investor from "components/investor";
import InvestorPackage from "components/investorPackages";
import AddInvestorRoute from "components/investor/AddInvestorPage";
import ViewInvestorByID from "components/investor/ViewInvestorByID";
import ManualDelivery from "components/investor/manual-delivery";
import ManageMortgageClasValidationSettings from "components/MortgageClasValidation/ManageMortgageClasValidationSettings/index";
import MersInvestorConfigSettings from "components/mers";
import WarehouseBank from "components/warehouse-bank";
import ManageInvestors from "components/manage-investors";
import ManageCounty from "components/manage-county";
import InvestorDeliveryInvoiceDetail from "components/investor-delivery-invoice-detail";
import MersInvoiceDetail from "components/mers-invoice-detail";

const MainRoutes = () => (
  <Routes>
    <Route path="/" element={<ProtectedRoutes />}>
      <Route>
        <Route path="/" element={<Dashboard />}>
          <Route path="customers" element={<Customers />} />
          <Route path="applications" element={<Applications />} />
          <Route path="external-system" element={<ExternalSystems />} />
          <Route path="users" element={<Users />} />
          <Route path="users/add-users" element={<AddUsers />} />
          <Route path="reports" element={<Reports />} />
          <Route path="reports/:id" element={<Reports />} />
          <Route path="coming-soon" element={<ComingSoon />} />
          <Route path="investor/admin" element={<InviestorAdmin />} />
          <Route path="adhocJob/jobs" element={<AdhocJobAdmin />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="investor" element={<Investor />} />
          <Route path="investor/package" element={<InvestorPackage />} />
          <Route path="investor/manual-delivery" element={<ManualDelivery />} />
          <Route
            path="invoices/investor-delivery-invoice"
            element={<InvestorDeliveryInvoiceDetail />}
          />
          <Route path="invoices/mers-invoice" element={<MersInvoiceDetail />} />
          <Route
            path="investor-config-seetings/:applicationId"
            element={<MersInvestorConfigSettings />}
          />
          <Route path="warehouse-bank" element={<WarehouseBank />} />
          <Route path="manage-investors" element={<ManageInvestors />} />
          <Route path="manage-county" element={<ManageCounty />} />
          <Route path="investor/:id" element={<ViewInvestorByID />} />
          <Route path="addInvestor" element={<AddInvestorRoute />} />
          <Route
            path="manage-settings"
            element={<ManageMortgageClasValidationSettings />}
          />
          <Route path="" element={<Navigate replace to="customers" />} />
        </Route>
      </Route>
    </Route>

    <Route path="/" element={<PublicRoutes />}>
      <Route>
        <Route path="/" element={<Navigate replace to="login" />} />
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route
          path="complete-registration/:id"
          element={<CompleteRegistration />}
        />
      </Route>
    </Route>
  </Routes>
);

export default MainRoutes;
